import MarkdownIt from 'markdown-it'

const handlePlugin = (plugin) => plugin.default || plugin

export default ({}, inject) => {
  const md = new MarkdownIt('default', {"linkify":true,"breaks":true,"injected":true})

  md.use(handlePlugin(require('markdown-it-link-attributes')), {"matcher":function(href, config) {
        return href.includes('agb') || href.includes('sparkasse.de');
      },"attrs":{"target":"_blank","rel":"noopener"}} )

  inject('md', md)
}